import { List, styled } from "@mui/material";

export const NumberedList = styled(List)(() => ({
  listStyleType: "decimal",
  counterReset: "list-item",
  padding: 0,
  "& .MuiListItemText-primary": {
    fontSize: "18px",
  },
  "& > li": {
    counterIncrement: "list-item",
    marginLeft: "20px",
    paddingLeft: "5px",
    color: "#15121A",
    display: "list-item",
    "&::marker": {
      content: "counter(list-item) ' '",
      fontWeight: 900,
      fontSize: "20px",
      color: "#15121A",
    },
  },
}));
